module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#c01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-head"
  }, [_c('span', {
    staticClass: "bborder"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#c01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast and Smoothies")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "60vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/3-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ChapbText"
  }, [_vm._v("When I start my day off by eating something healthy, I feel motivated to keep eating lighter recipes all day long. I’m not going to have a delicious Nutrient-Rich Kale Smoothie ("), _c('a', {
    attrs: {
      "href": "#/OEBPS/sect9#page20"
    }
  }, [_vm._v("here")]), _vm._v(") and then follow that up with a lunch of a burger and fries. It just doesn’t make sense! From Banana Nut Bread ("), _c('a', {
    attrs: {
      "href": "#/OEBPS/sect1#page4"
    }
  }, [_vm._v("here")]), _vm._v(") to Breakfast Stuffed Peppers ("), _c('a', {
    attrs: {
      "href": "#/OEBPS/sect7#page16"
    }
  }, [_vm._v("here")]), _vm._v(") and everything in between, there are plenty of ways to make sure you start your day off right.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42756142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 84
// module chunks = 0